import React from 'react';
export default function BioDrawerSection({ isActive, content }) {
  return (
    <section className={`bio-drawer-section ${isActive ? 'active' : ''}`}>
      {content}
    </section>
  );
}
